import React from "react";

import styled from "styled-components";

import module1Img from "../assets/gfx/module1-bg1.jpg";
import module2Img from "../assets/gfx/module-2-image.jpg";
import module3Img from "../assets/gfx/module-3-image.jpg";
import module4Img from "../assets/gfx/module-4-image.jpg";
import doneImg from "../assets/gfx/done-image.jpg";
import trophy from "../assets/svg/trophy-gold.svg";

import bikeImg from "../assets/gfx/bike-in-the-office.jpg";
import rightArrow from "../assets/svg/rightArrow.svg";
import clock from "../assets/svg/clock.svg";
import { useAppContextMethods, useGlobalUserMethods } from "~/state";

interface Data {
  imgSrc: string;
  title: string;
  body: JSX.Element;
  showFooter: boolean;
}

const data: Data[] = [
  {
    imgSrc: module1Img,
    title: "Module 1",
    body: <p>Introduction to workplace health</p>,
    showFooter: true,
  },
  {
    imgSrc: module2Img,
    title: "Module 2",
    body: <p>Motivating staff to be healthy</p>,
    showFooter: true,
  },
  {
    imgSrc: module3Img,
    title: "Module 3",
    body: <p>Best practice workplace health promotion</p>,
    showFooter: true,
  },
  {
    imgSrc: module4Img,
    title: "Module 4",
    body: <p>Planning your program</p>,
    showFooter: true,
  },
  {
    imgSrc: doneImg,
    title: "DONE!",
    body: (
      <>
        <p className="mb-4">Receive a certificate of completion</p>
        <img
          className="d-block mx-auto"
          src={trophy}
          alt="trophy"
          width={40}
          height={40}
        />
      </>
    ),
    showFooter: false,
  },
];

interface StartProps {}

export const Start: React.FC<StartProps> = () => {
  const { scrollToTop } = useAppContextMethods();
  const { goToRegistration } = useGlobalUserMethods();

  return (
    <FullPage>
      <PageHeader>
        <div className="bg-overlay-blueberry-dark text-center px-4 py-5">
          <div className="py-5">
            <PageTitle className="text-gold">Workplace Health</PageTitle>
            <h2 className="h3 text-white">
              Welcome to the Workplace Health Coordinator Training!
            </h2>
          </div>
        </div>
      </PageHeader>

      <p className="d-block w-50 lead text-center text-info mx-auto mb-4">
        This course will give you the knowledge and skills to develop an
        effective workplace health and wellbeing program
      </p>
      <div className="bg-light card-group p-3 mb-4">
        {data.map(({ imgSrc, title, body, showFooter }, idx) => (
          <ModuleCard active={idx === 0} key={idx} className="card">
            <img className="card-img-top" src={imgSrc} alt={`${title} image`} />
            <div className="card-body">
              <h4 className="h5 card-title">{title}</h4>
              {body}
            </div>
            {showFooter && (
              <div
                className="card-footer"
                style={{ background: "transparent" }}
              >
                <img src={clock} alt="clock" width={20} height={20} />
                <small className="text-muted ml-2">20 mins</small>
              </div>
            )}
          </ModuleCard>
        ))}
      </div>

      <p className="d-block w-75 mx-auto text-center mb-4">
        You can pause the training at any time. When you want to stop, save the
        web address and return to the same browser anytime to resume (cookies
        and javascript must be enabled).
      </p>
      <button
        onClick={(e) => {
          e.preventDefault();
          scrollToTop();
          goToRegistration();
        }}
        className="d-block btn btn-lg btn-info mx-auto mb-4"
        type="button"
      >
        Click here to get started
      </button>
    </FullPage>
  );
};

const FullPage = styled.div`
  margin: 0 -2rem 2rem;
`;

const PageHeader = styled.section`
  background-image: url(${bikeImg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 1.5rem;
`;

const PageTitle = styled.h1`
  font-size: 3em;
  margin-bottom: 1.5rem;
`;

const ModuleCard = styled.div<{ active: boolean }>`
  margin: 0 2rem;
  border: ${(p) => p.active && `2px solid ${p.theme.gold}`};

  h4 {
    color: ${(p) => p.active && p.theme.warning};
  }

  &:not(:last-of-type)::after {
    content: "";
    position: absolute;
    padding: 0.75rem;
    top: calc(50% - 0.75rem);
    right: calc(-1rem - 0.75rem);
    width: 1.5rem;
    height: 1.5rem;
    background-image: url(${rightArrow});
    background-size: 45%;
    background-position: center;
    background-repeat: no-repeat;
    background-color: ${(p) => p.theme.info};
    border-radius: 50%;
  }
`;
